import { render, staticRenderFns } from "./DialogEditArticleDate.vue?vue&type=template&id=e0b65cee&scoped=true"
import script from "./DialogEditArticleDate.vue?vue&type=script&lang=js"
export * from "./DialogEditArticleDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b65cee",
  null
  
)

export default component.exports